//() => import('@/pages/home')

function stripTabbar(to, path) {
  const query = Object.assign({}, to.query)
  delete query.tabbar
  return { path, query }
}

function dropTabbarQuery(to, from, next) {
  if (to.query && Object.prototype.hasOwnProperty.call(to.query, 'tabbar')) {
    next(Object.assign({ replace: true }, stripTabbar(to, to.path)))
    return
  }
  next()
}
// 资源管理、接单与收益栏目暂时屏蔽，恢复时取消注释
// import store from './vuex/store'
// import { Message } from 'element-ui'

//添加资源页进入守卫：仅媒体用户(is_media=1)可进入
/*
const mediaEnterGuard = (to, from, next) => {
    const verify = () => {
        if (Number(store.state.profile.is_media) === 1) {
            next()
        } else {
            Message.warning('请联系集易欧顾问，开通媒体入驻功能')
            next('/')
        }
    }

    //用户信息已加载完成，直接判断
    if (store.state.auth.isDone) {
        verify()
        return
    }

    //用户信息尚未加载完成（如直接通过URL访问），等待加载完成后再判断
    let times = 0
    const timer = setInterval(() => {
        times++
        if (store.state.auth.isDone || times >= 25) {
            clearInterval(timer)
            verify()
        }
    }, 200)
}
*/

const blockPausedRoute = (to, from, next) => {
    next('/')
}

export default [
  {
    path: '/home',
    name: 'portal',
    component: () => import('./components/home/Portal.vue'),
    meta: {
      title: '首页',
      auth: false,
      verify: false
    }
  },
  {
    path: '/',
    name: 'i',
    component: () => import('./components/home/Index.vue'),
    meta: {
      title: '个人中心',
      auth: true,
      verify: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('./components/auth/Login.vue'),
    meta: {
      title: '登录',
      auth: true,
      verify: false
    }
  },
  {
    path: '/retrievepwd',
    name: 'retrievepwd',
    component: () => import('./components/auth/RetrievePwd.vue'),
    meta: {
      title: '找回密码',
      auth: true,
      verify: false
    }
  },
  {
    path: '/signup',
    name: 'signup',
    component: () => import('./components/auth/Signup.vue'),
    meta: {
      title: '注册',
      auth: true,
      verify: false
    }
  },
  {
    path: '/cart',
    component: () => import('./components/cart/Index.vue'),
    meta: {
      title: '购物车',
      verify: true
    }
  },
  {
    path: '/recharge_center',
    component: () => import('./components/finance/RechargeCenterOne.vue'),
    meta: {
      title: '我要充值',
      verify: true
    }
  },
  {
    path: '/recharge_success',
    component: () => import('./components/finance/RechargeSuccess.vue'),
    meta: {
      title: '支付成功',
      verify: true
    }
  },
  {
    path: '/pre_order/:order_id',
    component: () => import('./components/pre_order/Index.vue'),
    meta: {
      title: '准备下单',
      verify: true
    }
  },
  {
    path: '/index/hotmedia',
    name: 'resource.geo',
    meta: {
      title: '优选GEO',
      verify: true
    },
    beforeEnter: dropTabbarQuery,
    component: () => import('./components/resource/geo/Index.vue')
  },
  {
    path: '/index/article',
    name: 'resource.news',
    meta: {
      title: '软文价格',
      verify: true
    },
    beforeEnter: dropTabbarQuery,
    component: () => import('./components/resource/news/Index.vue')
  },
  {
    path: '/index/zimeiti',
    name: 'resource.zimeiti',
    meta: {
      title: '自媒体推广',
      verify: true
    },
    beforeEnter: dropTabbarQuery,
    component: () => import('./components/resource/zimeiti/Index.vue')
  },
  {
    path: '/index/create',
    component: () => import('./components/own/Index.vue'),
    children: [
      {
        path: '',
        meta: {
          title: '文章发布',
          verify: true
        },
        component: () => import('./components/manuscript/Create/News.vue')
      }
    ]
  },
  {
    path: '/index/order',
    component: () => import('./components/own/Index.vue'),
    children: [
      {
        path: '',
        name: 'news_order',
        meta: {
          title: '软文订单中心',
          verify: true
        },
        component: () => import('./components/news_order/Index.vue')
      }
    ]
  },
  {
    path: '/resource',
    meta: {
      title: '媒体',
      unRedirect: true,
      verify: false
    },
    redirect: '/resource/woa',
    component: () => import('./components/resource/Index.vue'),
    children: [
      {
        path: 'news',
        redirect: to => stripTabbar(to, '/index/article')
      },
      {
        path: 'geo',
        redirect: to => stripTabbar(to, '/index/hotmedia')
      },
      {
        path: 'zimeiti',
        redirect: to => stripTabbar(to, '/index/zimeiti')
      },
      {
        path: '400',
        name: 'resource.400',
        meta: {
          title: '400电话',
          verify: true
        },
        component: () => import('./components/resource/400/Index.vue')
      },
      {
        path: 'brand',
        name: 'resource.brand',
        meta: {
          title: '商标转让',
          verify: true
        },
        component: () => import('./components/resource/brand/Index.vue')
      },
      {
        path: 'wxdyy',
        name: 'resource.wxdyy',
        meta: {
          title: '微信代运营',
          verify: true
        },
        component: () => import('./components/resource/wxdyy/Index.vue')
      },
      {
        path: 'woa',
        name: 'resource.woa',
        meta: {
          title: '微信公众号',
          unRedirect: true,
          verify: false
        },
        component: () => import('./components/resource/woa/Index.vue')
      },
      {
        path: 'flow',
        name: 'resource.flow',
        meta: {
          title: '信息流',
          unRedirect: true,
          verify: false
        },
        component: () => import('./components/resource/flow/Index.vue')
      },
      {
        path: 'flowPlan',
        name: 'resource.flowPlan',
        meta: {
          title: '信息流广告投放',
          unRedirect: true,
          verify: false
        },
        component: () =>
            import('./components/resource/flow/flowplan.vue')
      },
      {
        path: 'weibo',
        name: 'resource.weibo',
        meta: {
          title: '微博',
          unRedirect: true,
          verify: false
        },
        component: () => import('./components/resource/weibo/Index.vue')
      },
      {
        path: 'live',
        name: 'resource.live',
        meta: {
          title: '直播',
          unRedirect: true,
          verify: false
        },
        component: () => import('./components/resource/live/Index.vue')
      },
      {
        path: 'video',
        name: 'resource.video',
        meta: {
          title: '短视频',
          unRedirect: true,
          verify: false
        },
        component: () => import('./components/resource/video/Index.vue')
      },
      {
        path: 'xhs',
        name: 'resource.xhs',
        meta: {
          title: '小红书',
          unRedirect: true,
          verify: false
        },
        component: () => import('./components/resource/xhs/Index.vue')
      }
    ]
  },
  {
    path: '/own',
    name: 'own',
    component: () => import('./components/own/Index.vue'),
    redirect: '/own/order',
    children: [
      {
        path: 'order',
        name: 'order',
        meta: {
          title: '订单中心',
          verify: true
        },
        component: () => import('./components/order/Index.vue')
      },
      {
        path: 'news_order',
        redirect: to => ({ path: '/index/order', query: to.query })
      },
      {
        path: 'order/:id',
        name: 'order.show',
        meta: {
          title: '订单详细',
          verify: true
        },
        component: () => import('./components/order/Show.vue')
      },
      {
        path: 'order_item',
        name: 'order.item',
        meta: {
          title: '子订单详情',
          verify: true
        },
        component: () => import('./components/order/Item.vue')
      },
      {
        path: 'ghostwrite',
        name: 'ghostwrite',
        meta: {
          title: '文章代写',
          verify: true
        },
        component: () => import('./components/ghostwrite/Index.vue')
      },
      {
        path: 'ghostwrite/create',
        name: 'ghostwrite.create',
        meta: {
          title: '新建代写',
          verify: true
        },
        component: () => import('./components/ghostwrite/Create.vue')
      },
      {
        path: 'manuscripts',
        name: 'manuscript',
        meta: {
          title: '稿件管理',
          verify: true
        },
        component: () => import('./components/manuscript/Index.vue')
      },
      {
        path: 'manuscripts/copy_write',
        name: 'copy_write',
        meta: {
          title: '稿件代写',
          verify: true
        },
        component: () => import('./components/manuscript/CopyWrite.vue')
      },
      {
        path: 'copy_write',
        name: 'copy_write',
        meta: {
          title: '文章代写',
          verify: true
        },
        component: () => import('./components/manuscript/CopyWrite.vue')
      },
      {
        path: 'copy_write_list',
        name: 'copy_write_list',
        meta: {
          title: '代写列表',
          verify: true
        },
        component: () => import('./components/copyWriteList/Index.vue')
      },
      {
        path: 'manuscripts/:id/edit/woa',
        name: 'manuscript.edit.woa',
        meta: {
          title: '稿件修改',
          _meta: 'edit',
          verify: true
        },
        component: () =>
            import(/* webpackChunkName: "manuscriptsEditWoa" */ './components/manuscript/Create/Woa.vue')
      },
      {
        path: 'manuscripts/:id/edit/weibo',
        meta: {
          title: '稿件修改',
          _meta: 'edit',
          verify: true
        },
        component: () =>
            import(/* webpackChunkName: "manuscriptsWeiboCreate" */ './components/manuscript/Create/Weibo.vue')
      },
      {
        path: 'manuscripts/:id/edit/live',
        meta: {
          title: '稿件修改',
          _meta: 'edit',
          verify: true
        },
        component: () =>
            import(/* webpackChunkName: "manuscriptsWeiboLive" */ './components/manuscript/Create/Live.vue')
      },
      {
        path: 'manuscripts/:id/edit/news',
        meta: {
          title: '稿件修改',
          _meta: 'edit',
          verify: true
        },
        component: () =>
            import('./components/manuscript/Create/News.vue')
      },
      {
        path: 'manuscripts/:id/create/news',
        meta: {
          title: '稿件重发',
          verify: true
        },
        component: () =>
            import('./components/manuscript/Create/News.vue')
      },
      {
        path: 'manuscripts/:id/edit/video',
        meta: {
          title: '稿件修改',
          _meta: 'edit',
          verify: true
        },
        component: () =>
            import('./components/manuscript/Create/Video.vue')
      },
      {
        path: 'manuscripts/:id/edit/xhs',
        meta: {
          title: '稿件修改',
          _meta: 'edit',
          verify: true
        },
        component: () =>
            import('./components/manuscript/Create/Xhs.vue')
      },
      {
        path: 'manuscripts/create/woa',
        meta: {
          title: '创建微信公众号稿件',
          verify: true
        },
        component: () =>
            import('./components/manuscript/Create/Woa.vue')
      },
      {
        path: 'manuscripts/create/live',
        meta: {
          title: '创建网红直播稿件',
          verify: true
        },
        component: () =>
            import('./components/manuscript/Create/Live.vue')
      },
      {
        path: 'manuscripts/create/news',
        meta: {
          title: '创建软文推广稿件',
          verify: true
        },
        component: () =>
            import('./components/manuscript/Create/News.vue')
      },
      {
        path: 'publish',
        redirect: to => ({ path: '/index/create', query: to.query })
      },
      {
        path: 'publish_multi',
        meta: {
          title: '多标题文章发布',
          verify: true
        },
        component: () =>
          import('./components/manuscript/Create/NewsMulti.vue')
      },
      {
        path: 'publish_batch',
        meta: {
          title: '批量投放',
          verify: true
        },
        component: () =>
          import('./components/manuscript/Create/NewsBatch.vue')
      },
      {
        path: 'aiwrite',
        meta: {
          title: 'AI生成文章',
          verify: true
        },
        component: () =>
            import('./components/deepseek/index.vue')
      },
      {
        path: 'manuscripts/create/video',
        meta: {
          title: '创建短视频稿件',
          verify: true
        },
        component: () =>
            import('./components/manuscript/Create/Video.vue')
      },
      {
        path: 'manuscripts/create/weibo',
        meta: {
          title: '创建微博稿件',
          verify: true
        },
        component: () =>
            import('./components/manuscript/Create/Weibo.vue')
      },
      {
        path: 'manuscripts/create/xhs',
        meta: {
          title: '创建小红书稿件',
          verify: true
        },
        component: () =>
            import('./components/manuscript/Create/Xhs.vue')
      },
      {
        path: 'finance',
        name: '财务中心',
        component: () => import('./components/finance/Index.vue'),
        redirect: '/own/finance/recharge',
        children: [
          {
            path: 'transaction',
            meta: {
              title: '财务报表',
              verify: true
            },
            component: () =>
                import('./components/transaction/Index.vue')
          },
          {
            path: 'transaction/:order_id',
            meta: {
              title: '交易明细',
              verify: true
            },
            component: () =>
                import('./components/transaction/Show.vue')
          },
          {
            path: 'withdrawals',
            meta: {
              title: '提现',
              verify: true
            },
            component: () =>
                import('./components/finance/Withdrawals.vue')
          },
          {
            path: 'invoice',
            meta: {
              title: '发票',
              verify: true
            },
            component: () =>
                import('./components/invoice/Index.vue')
          },
          {
            path: 'invoice_list',
            meta: {
              title: '发票列表',
              verify: true
            },
            component: () =>
                import('./components/invoiceList/Index.vue')
          },
          {
            path: 'invoice_info_list',
            meta: {
              title: '发票信息审核',
              verify: true
            },
            component: () =>
                import('./components/invoiceInfoList/Index.vue')
          },
          {
            path: 'invoice/create',
            meta: {
              title: '发票信息',
              verify: true
            },
            component: () =>
                import('./components/invoice/Create.vue')
          },
          {
            path: 'address',
            meta: {
              title: '邮箱地址管理',
              verify: true
            },
            component: () =>
                import('./components/address/Index.vue')
          },
          {
            path: 'address/create',
            meta: {
              title: '新增邮寄地址',
              verify: true
            },
            component: () =>
                import('./components/address/Create.vue')
          }
        ]
      },
      {
        path: 'personal',
        component: () => import('./components/personal/Index.vue'),
        children: [
          {
            path: 'profile',
            meta: {
              title: '个人资料',
              verify: true
            },
            component: () =>
                import('./components/personal/Profile.vue')
          },
          {
            path: 'password',
            meta: {
              title: '密码修改',
              verify: true
            },
            component: () =>
                import('./components/personal/Password.vue')
          },
          {
            path: 'avatar',
            meta: {
              title: '头像上传',
              verify: true
            },
            component: () => import('./components/avatar/Index.vue')
          },
          {
            path: 'mobile',
            meta: {
              title: '修改手机号码',
              verify: true
            },
            component: () =>
                import('./components/personal/Mobile.vue')
          },
          {
            path: 'resource_add',
            meta: {
              title: '添加资源',
              verify: true
            },
            beforeEnter: blockPausedRoute,
            component: () =>
                import('./components/personal/AddResource.vue')
          },
          {
            path: 'resource_list',
            meta: {
              title: '我的资源',
              verify: true
            },
            beforeEnter: blockPausedRoute,
            component: () =>
                import('./components/personal/MyResource.vue')
          },
          {
            path: 'manager_resource',
            meta: {
              title: '已入系统',
              verify: true
            },
            beforeEnter: blockPausedRoute,
            component: () =>
                import('./components/personal/ManagerResource.vue')
          },
          {
            path: 'own_order',
            meta: {
              title: '我的订单',
              verify: true
            },
            beforeEnter: blockPausedRoute,
            component: () =>
                import('./components/personal/OwnOrder.vue')
          },
          {
            path: 'own_income',
            meta: {
              title: '我的收益',
              verify: true
            },
            beforeEnter: blockPausedRoute,
            component: () =>
                import('./components/personal/OwnIncome.vue')
          },
          {
            path: 'withdraw_list',
            meta: {
              title: '收益提现',
              verify: true
            },
            beforeEnter: blockPausedRoute,
            component: () =>
                import('./components/personal/WithdrawList.vue')
          }
          //  {
          //     path: 'collect',
          //     component: () => import("./components/personal/Collect.vue"),
          //     meta: {
          //         title: "收藏中心"
          //     }
          // }
        ]
      }
    ]
  },
  {
    path: '/manuscripts/:id',
    name: 'manuscript_preview',
    meta: {
      title: '稿件预览',
      silent: true,
      verify: false
    },
    component: () => import('./components/manuscript/Show.vue')
  },
  {
    path: '/pay_success',
    name: '支付成功',
    meta: {
      title: '',
      verify: true
    },
    component: () => import('./components/global/PaySuccess.vue')
  },
  {
    path: '/recommand',
    meta: {
      title: '智能推荐'
    },
    component: () => import('./components/recommand/Index.vue')
  },
  {
    path: '/error',
    name: '404',
    meta: {
      title: '404',
      verify: false
    },
    component: () => import('./components/global/404.vue')
  },
  {
    path: '/manuscript_edit/:key',
    meta: {
      title: '编辑器',
      silent: true,
      verify: false
    },
    component: () => import('./components/editor/Index.vue')
  },
  {
    path: '*',
    redirect: '/error'
  }
]



// WEBPACK FOOTER //
// ./src/Routes.js